export default __webpack_public_path__ + "static/media/cloudy-day.3698c4bb.mp4";